import "./Pricing.module.css";
import Header from "@/reusable_sections/Header";
import Pricing from "./sections/Pricing";
import Investment from "./sections/Investment";
import PricingQuestions from "./sections/PricingQuestions";
import Footer from "@/reusable_sections/Footer";
export default function PricingPage() {
  return <div>
      <Header />
      <Pricing />
      <Investment />
      <PricingQuestions />
      <Footer />
    </div>;
}